import React, { useState, useEffect } from "react";
import { Inner } from "./styles";
import { Form, Input, Button, Select, Tooltip, Divider, Row, Col } from "antd";

import { Footer } from "../../../../styles";
import FloatingLabel from "../../../../../floatingLabel/FloatingLabel";

import { ButtonsFixedFooter, Buttons } from "../../styles";
import { get_bank_account_types, get_bank_branches, get_banks, get_currencies } from "../../../../../../../api/endpoints/sysone-endpoints/sysoneEndpoints";
const { Option } = Select;

export default function CreatePaymentDebit({
	onCreate,
	setAddPaymentMethodMode,
	fixedFooter
}) {

	const [form] = Form.useForm();
	const [banks, setBanks] = useState([]);
	const [bankAccountTypes, setBankAccountTypes] = useState([]);
	const [currencies, setCurrencies] = useState([]);
	const [bankBranches, setBankBranches] = useState([]);

	const formValues = Form.useWatch([], form);
	const bank = Form.useWatch("bank", form);

	useEffect(() => {
		const fetch_banks = async () => {
			const data = await get_banks()
			setBanks(data.values || []);
		};

		const fetch_currencies = async () => {
			const data = await get_currencies()
			setCurrencies(data.values || []);
		};

		const fetch_bank_account_types = async () => {
			const data = await get_bank_account_types()
			setBankAccountTypes(data.values || []);
		};

		fetch_banks();
		fetch_currencies();
		fetch_bank_account_types();
	}, []);

	const onBankChange = async (value) => {
		form.setFieldsValue({ debit_subsidiary: null });
		if (!value) {
			setBankBranches([]);
			return;
		}
		const data = await get_bank_branches(value)
		setBankBranches(data.values || []);
		form.setFieldsValue({ debit_subsidiary: data.values[0]?.code });
	};

	const resetForm = () => {
		form.resetFields();
	};

	const onFinish = async (values) => {
		try {
			const post_data = {
				bankAccountType: {
					code: values.debit_accountType,
					name: bankAccountTypes.find(
						(i) => i.code === values.debit_accountType
					).name,
				},
				bankBranch: {
					bank: {
						name: bankBranches[0]?.bank.name,
						code: values.bank,
					},
					code: bankBranches[0]?.code,
					name: bankBranches[0]?.name,
				},
				currency: {
					code: values.debit_currency,
				},
				number: "2222222222",
				cbu: values.debit_cbu,
				type: "bankAccountData",
			};

			resetForm();
			onCreate(post_data);
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<Inner>
			<Form
				form={form}
				name="create-debit-form"
				layout="vertical"
				onFinish={onFinish}
			>
				<FloatingLabel
					label={"Banco"}
					hint={"Banco"}
					value={formValues?.bank}
				>
					<Form.Item
						name="bank"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
						]}
					>
						<Select
							allowClear={true}
							onChange={onBankChange}
							showSearch
							optionFilterProp="children"
							filterOption={(input, option) =>
								option.children.toLowerCase().includes(input.toLowerCase())
							}
						>
							{banks.map((bank) => (
								<Option key={bank.code} value={bank.code}>
									{bank.name}
								</Option>
							))}
						</Select>
					</Form.Item>
				</FloatingLabel>

				<Row gutter={20}><Col span={12}><FloatingLabel
					label={"Tipo de cuenta"}
					value={formValues?.debit_accountType}
					hint={"Tipo de cuenta"}
				>
					<Form.Item
						name="debit_accountType"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
						]}
					>
						<Select allowClear={true} disabled={!formValues?.bank}>
							{bankAccountTypes.map((accountType) => (
								<Option key={accountType.code} value={accountType.code}>
									{accountType.name}
								</Option>
							))}
						</Select>
					</Form.Item>
				</FloatingLabel>
				</Col><Col span={12}><FloatingLabel
					label={"Moneda"}
					value={formValues?.debit_currency}
					hint={"Moneda"}
				>
					<Form.Item
						name="debit_currency"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
						]}
					>
						<Select
							allowClear={true}
							disabled={
								!formValues?.bank || !currencies || currencies?.length === 0
							}
						>
							{currencies.map((currency) => (
								<Option key={currency.code} value={currency.code}>
									{currency.name}
								</Option>
							))}
						</Select>
					</Form.Item>
				</FloatingLabel></Col>
				</Row>

				{/* <FloatingLabel
					label={t("branch-office-lbl")}
					value={formValues?.debit_subsidiary}
					hint={t("branch-office-hint")}
				>
					<Form.Item
						name="debit_subsidiary"
						rules={[
							{
								required: true,
								message:"Campo requerido",
							},
						]}
					>
						<Select
							allowClear={true}
							disabled={
								!formValues?.bank || !bankBranches || bankBranches?.length === 0
							}
						>
							{bankBranches.map((branch) => (
								<Option key={branch.code} value={branch.code}>
									{branch.name}
								</Option>
							))}
						</Select>
					</Form.Item>
				</FloatingLabel> */}

				{/* <FloatingLabel
					label={t("account-number-lbl")}
					value={formValues?.debit_accountNumber}
					hint={t("account-number-hint")}
				>
					<Form.Item
						name="debit_accountNumber"
						rules={[
							{
								required: true,
								message:"Campo requerido",
							},
						]}
					>
						<Input type="number" disabled={!formValues?.bank} />
					</Form.Item>
				</FloatingLabel> */}

				<FloatingLabel
					label={"CBU"}
					value={formValues?.debit_cbu}
					hint={"CBU"}
				>
					<Form.Item
						name="debit_cbu"
						rules={[
							{
								required: true,
								message: "Campo requerido",
							},
							{
								min: 22,
								max: 22,
								message: "Debe contener 22 caracteres",
							},
						]}
					>
						<Input
							type="text"
							disabled={!formValues?.bank}
							maxLength={22}
							onChange={(e) => {
								const value = e.target.value.replace(/\D/g, ''); // Solo números
								if (value.length <= 22) {
									form.setFieldsValue({ debit_cbu: value });
								}
							}} />
					</Form.Item>
				</FloatingLabel>



				<Form.Item>
					{fixedFooter ? (
						<Footer>
							<Divider />
							<ButtonsFixedFooter>
								<Button
									type="secondary"
									onClick={() => setAddPaymentMethodMode(false)}
									htmlType="button"
								>
									{"Cancelar"}
								</Button>
								<Button type="primary" htmlType="submit">
									{"Agregar"}
								</Button>
							</ButtonsFixedFooter>
						</Footer>
					) : (
						<Buttons>
							<Button
								type="secondary"
								onClick={() => setAddPaymentMethodMode(false)}
								htmlType="button"
							>
								{"Cancelar"}
							</Button>
							<Button type="primary" htmlType="submit">
								{"Agregar"}
							</Button>
						</Buttons>
					)}
				</Form.Item>
			</Form>
		</Inner>
	);
}
